import { render } from "./RequestsClientTable.vue?vue&type=template&id=90880522&scoped=true"
import script from "./RequestsClientTable.vue?vue&type=script&lang=js"
export * from "./RequestsClientTable.vue?vue&type=script&lang=js"

import "./RequestsClientTable.vue?vue&type=style&index=0&id=90880522&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90880522"]])

export default __exports__